module.exports = __webpack_public_path__ + "ca813c16a62787795f14a2add3f1a8ac.MP3";